import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";

import { HomePage, SettingsPage, ProfilePage } from "../pages";
import { usePermanentNotifications } from "../store/shared/usePermanentNotifications/usePermanentNotifications";
import { isSS } from "../store/info";

export const AppRouter = () => {
  usePermanentNotifications();

  const isUserSS = useSelector(isSS);

  return (
    <Routes>
      <Route path="home" element={<HomePage />} />
      <Route path="settings/*" element={<SettingsPage />} />
      {!isUserSS && <Route path="profile/:id" element={<ProfilePage />} />}
      <Route path="*" element={<Navigate to="/home" />} />
    </Routes>
  );
};
